import type { FC, ReactElement, ReactNode } from "react";

import classNames from "classnames";

import { changeFilter } from "../../../../filters/ngFilters";
import type { ITableCellProps } from "../interfaces/ITableCellProps";

interface IChangePercentageCellProps extends Partial<Pick<ITableCellProps, "value" | "row">> {
    classes?: string;
    /** Overrides how the (already absolute) value is formatted. Defaults to the percentage formatter. */
    formatValue?: (absValue: number) => ReactNode;
}

type ChangePercentageProps = Pick<ITableCellProps, "value"> &
    Partial<Pick<ITableCellProps, "row">> &
    Pick<IChangePercentageCellProps, "formatValue">;

const ChangePercentageCell = ({ value, row, classes, formatValue }: IChangePercentageCellProps): ReactElement => {
    const iconClasses = classNames("changePercentage-icon", {
        "sw-icon-arrow-up5": value > 0,
        "sw-icon-arrow-down5": value < 0,
    });
    const displayValue = formatValue ? formatValue(Math.abs(value)) : changeFilter()(Math.abs(value), row?.precision);
    return (
        <div className={classes}>
            <i className={iconClasses} /> {displayValue}
        </div>
    );
};

/**
 * @deprecated Use ChangeCell from @similarweb/pro-logic-components instead
 * @see {@link https://gitlab.int.similarweb.io/pro-frontend/pro-logic-components/-/blob/master/src/table/cells/components/views/change-cell/ChangeCell.tsx}
 */

export const ChangePercentage: FC<ChangePercentageProps> = (props) => {
    const classes = classNames("changePercentage", {
        negative: props.value < 0,
        positive: props.value > 0,
    });

    return (
        <ChangePercentageCell
            {...props}
            classes={classes}
        />
    );
};
ChangePercentage.displayName = "ChangePercentage";

/**
 * @deprecated Use ChangeCell from @similarweb/pro-logic-components instead
 * @see {@link https://gitlab.int.similarweb.io/pro-frontend/pro-logic-components/-/blob/master/src/table/cells/components/views/change-cell/ChangeCell.tsx}
 */

export const ChangePercentageBackward: FC<ChangePercentageProps> = (props) => {
    const classes = classNames("changePercentage", {
        negative: props.value > 0,
        positive: props.value < 0,
    });

    return (
        <ChangePercentageCell
            {...props}
            classes={classes}
        />
    );
};
ChangePercentageBackward.displayName = "ChangePercentageBackward";
